<template>
  <v-container fill-height fluid grid-list-xl>
    <v-flex>
     
      <app-upsert :config="config" :item="item" @saved="saved">
        <template slot="headerActions">
          <v-btn color="secondary" @click="$router.push('/landingpages')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <!--v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  color="secondary"
                  @click="open_in_new()">
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>

              </template>
              <span>Open New User Survey in new tab</span>
            </v-tooltip>


             <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  color="secondary"
                   @click="$router.push('/protocol_details/' + protocol.id)">
                  <v-icon>mdi-clipboard-edit-outline</v-icon>
                </v-btn>

              </template>
              <span>Open protocol details</span>
            </v-tooltip-->
        </template>

        <template slot="actions">
          <!--v-btn
            color="secondary"
            @click="$router.push('/protocol_roles/' + protocol.id)">
            Roles
          </v-btn-->
        </template>
      </app-upsert>
    </v-flex>
  </v-container>
</template>

<script>
import { getDetail } from "@/api/base_entity";
import config from "./config_upsert.js";
import { merge } from 'merge-anything'
import { mapActions } from "vuex";

export default {
  inheritAttrs: false,
  data() {
    return {
      config,
      item: {},
      itemId: null,
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.itemId = this.$route.params.id;
      this.getData();
    }
  },
  mounted() {
    this.getConfig()
  },
  computed: {
    isNew() {
      return this.item.id ? false : true;
    },
  },
  methods: {
    ...mapActions("app", ["getConfig"]),
    async getData() {
      this.item = await getDetail("landingpage", { id: this.itemId });
      this.item.entity = 'landingpage'
      delete this.item.text;

       var variablesFromTemplate =
        this.item.template && this.item.template.variablesFromTemplate
          ? this.item.template.variablesFromTemplate
          : [];

      if (this.isNew || !this.item.datamap || this.item.datamap.length == 0) {
        this.item.datamap = JSON.parse(JSON.stringify(variablesFromTemplate));
      }

      // controllo se la struttura del template è cambiata
      this.item.datamap = JSON.parse(
        JSON.stringify(merge(variablesFromTemplate, this.item.datamap))
      );
    },
    saved(item) {
      this.itemId = item.data.id;
      if(this.isNew) {
        this.$router.push("/landingpage/" + item.data.id);
      }
      this.getData();
    },
  },
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}
</style>
